// extracted by mini-css-extract-plugin
export default {"wrapper":"PrintEditor_wrapper__DRjTv","editWrapper":"PrintEditor_editWrapper__EfdY3","buttonWrapper":"PrintEditor_buttonWrapper__H7bsS"};